import { lazy } from 'react'

export const MealsPreparationV1 = lazy(() => import('./v1/MealsPreparationV1'))
